export default __webpack_public_path__ + "static/media/image.nova-tech-zone-pvt-ltd.6d8ed52c.png";